<template>
    <div class="d-flex flex-lg-wrap mb-4">
        <article class="additional-color selected mr-3 my-2">
            <div class="d-flex align-items-center">
                <div class="item-img-wrapper">
                    <a href="/" class="self">
                        <lazy-img
                            :image-url="currentItem.data.images.all[0].urlPreview || currentItem.data.images.all[0].urlMiddle"
                            picture-class="img-fluid"
                            :show-percentage="showPercentageItem"
                            :gray-overlay="true" >
                        </lazy-img>
                    </a>
                </div>
            </div>
        </article>
        <article v-for="(variation, index) in displayedVariations" :key="index" class="additional-color mr-3 my-2">
            <div class="d-flex align-items-center">
                <div class="item-img-wrapper">
                    <a :href="variation.data | itemURL">
                        <lazy-img
                            :image-url="variation.data.images.all[0].urlPreview || variation.data.images.all[0].urlMiddle"
                            :picture-class="getPictureClass(variation)"
                            :show-percentage="showPercentageSign(variation)"
                            :gray-overlay="true" 
                            :not-available="variation.data.variation.availabilityId > 7">
                        </lazy-img>
                    </a>
                </div>
            </div>
        </article>
        <div v-if="this.variations.length > itemsToShow && !showAll &&!isMobile && this.variations.length - this.itemsToShow != 1" @click="loadMore" class="additional-color mr-2">
            <div class="d-flex align-items-center">
                <div class="item-img-wrapper mr-2 position-relative more-items">
                    <span class="h4 position-absolute w-100 font-weight-bolder text-dark mb-0">
                        + {{ this.variations.length - itemsToShow }}
                    </span>
                    <lazy-img
                        :image-url="variations[itemsToShow].data.images.all[0].urlPreview || variations[itemsToShow].data.images.all[0].urlMiddle"
                        picture-class="img-fluid grayscale"
                        :gray-overlay="true" >
                    </lazy-img>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "additional-colors",
    props: {
        variations: {
            type: Array,
            required: true
        },
        currentItem: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            itemsToShow: 5,
            showAll: false,
            showPercentageItem: false,
            isMobile: false
        };
    },
    computed: {
        displayedVariations() {
            let sortedVariations = [...this.variations].sort((a, b) => {
                const availabilityA = a.data.variation.availabilityId;
                const availabilityB = b.data.variation.availabilityId;

                if (availabilityA > 7 && availabilityB <= 7) {
                    return 1; // a should come after b
                } else if (availabilityA <= 7 && availabilityB > 7) {
                    return -1; // a should come before b
                } else {
                    return 0; // no change in order
                }
            });

            if (this.showAll || this.isMobile || this.variations.length - this.itemsToShow == 1) {
                return sortedVariations;
            }
            return sortedVariations.slice(0, this.itemsToShow);
        }
    },
    mounted() {
        this.setShowPercentageItem();
        this.checkScreenSize();
        window.addEventListener('resize', this.checkScreenSize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkScreenSize);
    },
    methods: {
        loadMore() {
            this.showAll = true;
        },
        setShowPercentageItem() {
            this.currentItem.data.variationProperties.forEach(variationProperty => {
                if (variationProperty.property && 
                    ((variationProperty.property.id == 31 && variationProperty.values > 0) || 
                    (variationProperty.property.id == 39 && variationProperty.values && variationProperty.values.value && variationProperty.values.value.length > 0))) {
                    this.showPercentageItem = true;
                }
            });
        },
        showPercentageSign(variation) {
            return variation.data.variationProperties.some(variationProperty => 
                (variationProperty.property.id == 31 && variationProperty.values > 0) || 
                (variationProperty.property.id == 39 && variationProperty.values.value.length > 0)
            );
        },
        checkScreenSize() {
            this.isMobile = window.innerWidth <= 991;
        },
        getPictureClass(variation) {
            return variation.data.variation.availabilityId < 7 ? 'img-fluid' : 'img-fluid notAvailable';
        }
    }
};
</script>